.page {
    display: flex;
    height: 100%;
    width: 100%;
    max-width: 1728px;
    margin: 0 auto;
    overflow: hidden;
    padding-top: 15px;
}

.main {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: 0;
    position: relative;
    height: 100%;
    overflow: hidden; /* DocumentGeneratorBody owns its own form/preview scroll */
}

@media (min-width: 1200px) {
    .main {
        flex: 0 0 75%;
        max-width: 75%;
    }
}

.aside {
    display: none;
    height: 100%;
    overflow-y: auto;
    padding: var(--mantine-spacing-md);
}

@media (min-width: 1200px) {
    .aside {
        display: block;
        flex: 0 0 25%;
        max-width: 25%;
    }
}
